<script setup>
// VibeVox-брендинг: вместо дефолтного «пузыря» Chatwoot — фирменная иконка VibeVox.
// Если суперадмин задал свой logoThumbnail в настройках — уважаем его, иначе VibeVox.
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import vibevoxIcon from 'dashboard/assets/images/vibevox/vibevox-favicon.png';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img v-bind="attrs" :src="globalConfig.logoThumbnail || vibevoxIcon" />
</template>
